export const subscriptions = [
  {
    id: 11,
    channelName: "News 24",
    img: "https://yt3.ggpht.com/ytc/AL5GRJU8jTAYsZneshehUbEHbiaWyNl6fcTzDBiMGGx_3g=s88-c-k-c0x00ffffff-no-rj",
    ytLink: "https://www.youtube.com/@news24tvchannel",
    isLive: true,
  },
  {
    id: 1,
    channelName: "CodeWithHarry",
    img: `https://yt3.ggpht.com/ytc/AL5GRJX7LBvNaQFl0ODpVbrt2F4ajG_wY0fKpZGsEqi8Jw=s88-c-k-c0x00ffffff-no-rj`,
    ytLink: "https://www.youtube.com/@CodeWithHarry",
    isLive: false,
  },
  {
    id: 2,
    channelName: "Web Dev Simplified",
    img: "https://yt3.ggpht.com/ytc/AL5GRJXjrfspJ8wxKzvK-Q9qRfQGRPFGj1OfJGzDDDOp=s88-c-k-c0x00ffffff-no-rj",
    ytLink: "https://www.youtube.com/@WebDevSimplified",
    isLive: false,
  },
  {
    id: 3,
    channelName: "Thapa Technical",
    img: "https://yt3.ggpht.com/ytc/AL5GRJVyAJpYsYcRKdIU9Y-OFnIoCPyR6U4H7xe5JpGL8Q=s88-c-k-c0x00ffffff-no-rj",
    ytLink: "https://www.youtube.com/@ThapaTechnical",
    isLive: false,
  },
  {
    id: 4,
    channelName: "Coder Dost",
    img: "https://yt3.ggpht.com/m-FbG7zwy9uuelkhgj4BqkpSGuL29FCDaibjs6P5KmmACUgm5N4iAk2SbJNuHK7dBqUEvSEf=s88-c-k-c0x00ffffff-no-rj",
    ytLink: "https://www.youtube.com/@coderdost",
    isLive: false,
  },
  {
    id: 5,
    channelName: "Dave Gray",
    img: "https://yt3.ggpht.com/ytc/AL5GRJXtuktEGarPtsDfBBlRuEsXFSEreRnyz4eYchGQ1w=s88-c-k-c0x00ffffff-no-rj",
    ytLink: "https://www.youtube.com/@DaveGrayTeachesCode",
    isLive: false,
  },
  {
    id: 6,
    channelName: "Steve - Builder io",
    img: "https://yt3.ggpht.com/AQG3DNKvWvLbR22Oztb9jhrfZY89501l0qtrppfhs1-GpS6QVaVLwTPJH1hz_w9VQEaMLIga=s88-c-k-c0x00ffffff-no-rj",
    ytLink: "https://www.youtube.com/@Steve8708",
    isLive: false,
  },
  {
    id: 7,
    channelName: "JavaScript Mastery",
    img: "https://yt3.ggpht.com/wg1TITEoPfxvBGfzuqWyt3bqm_qu35ZhMswUv3feetU3xNX_6wsAXZF40OlPIgY4TmqbqCmAZ1U=s88-c-k-c0x00ffffff-no-rj",
    ytLink: "https://www.youtube.com/@javascriptmastery",
    isLive: false,
  },
  {
    id: 16,
    channelName: 'freeCodeCamp.org',
    img: 'https://yt3.ggpht.com/ytc/AL5GRJXPR4dSz0wwP-elkeiWUMnfZlCtNZP8Rd-tmFOZYg=s88-c-k-c0x00ffffff-no-rj',
    ytLink: 'https://www.youtube.com/@freecodecamp',
    isLive: false,
  },
  {
    id: 8,
    channelName: "WWE",
    img: "https://yt3.ggpht.com/ytc/AL5GRJUZFyRny7675ekwpWjMtg7QH5dgQ1tve8DuRHS4FPQ=s88-c-k-c0x00ffffff-no-rj",
    ytLink: "https://www.youtube.com/@WWE",
    isLive: false,
  },
  {
    id: 9,
    channelName: "Kevin Powell",
    img: "https://yt3.ggpht.com/ytc/AL5GRJUvyoz58-Shq477iC8w1Q0zl8Cp10Zmuo6Gw9YUrA=s88-c-k-c0x00ffffff-no-rj",
    ytLink: "https://www.youtube.com/@KevinPowell",
    isLive: false,
  },
  {
    id: 10,
    channelName: "Dhruv Rathee",
    img: "https://yt3.ggpht.com/oQ2NQMuq-9IS6_MZdsGXa0RWecaACremA01Z7jo-YpoEF1H6PyUF8PZzXkV10OYwSP3UMJDeTg=s88-c-k-c0x00ffffff-no-rj",
    ytLink: "https://www.youtube.com/@dhruvrathee",
    isLive: false,
  },
  {
    id: 12,
    channelName: "Physics Wallah - Alakh Pandey",
    img: "https://yt3.ggpht.com/ytc/AL5GRJW0_RETKmYwNCfTWPOzOpPXtparsg2iI9udJ9Q5dg=s88-c-k-c0x00ffffff-no-rj",
    ytLink: "https://www.youtube.com/@PhysicsWallah",
    isLive: false,
  },
  {
    id: 13,
    channelName: "Hyperplexed",
    img: "https://yt3.ggpht.com/qwPC2RPN6SOsb70GvAlHQJD7stY0frUAOgkPCJxpdz6UxIa_QcB8m9iidDAhSH2CccCyoKAi=s88-c-k-c0x00ffffff-no-rj",
    ytLink: "https://www.youtube.com/@Hyperplexed",
    isLive: false,
  },
  {
    id: 14,
    channelName: "Combo Classes Bonus",
    img: "https://yt3.ggpht.com/bL8jkW-Kx1kavSPCY9IV8Ji4HP7kXZAHbFnwMsabyDjXjyMWqieBE7QzVyWemqLo3dSzuOE0=s88-c-k-c0x00ffffff-no-rj",
    ytLink: "https://www.youtube.com/@Domotro",
    isLive: false,
  },
  {
    id: 15,
    channelName: "Linode",
    img: "https://yt3.ggpht.com/zH-5kUocR3POAfRnS4CpRV08LSgYODneZozqAML2cND2ynl-pA1NvtZdQHK9Ueg1aP-sq081=s88-c-k-c0x00ffffff-no-rj",
    ytLink: "https://www.youtube.com/@linode",
    isLive: false,
  },
];
